import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Build for portfolio services</title>
        <meta name="description" content="Build for portfolio services" />
        <meta property="og:title" content="Build for portfolio services" />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <link
          rel="canonical"
          href="https://silktechnologies.com/"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
*, *::before, *::after {
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.01ms !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="hero-section">
        <div className="hero-background">
          <video
            src="https://videos.pexels.com/video-files/35169660/14899004_640_360_30fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/35169660/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <canvas id="heroParticles" className="hero-canvas"></canvas>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>Next-Generation Technology Solutions</span>
            </div>
            <h1 className="hero-title home-hero-title">
              Transforming Ideas Into Digital Reality
            </h1>
            <p className="home-hero-subtitle hero-subtitle">
              Premium technology firm delivering cutting-edge solutions with 3D
              visualization, AI-powered automation, and reactive interfaces that
              elevate your digital presence.
            </p>
            <div className="hero-actions">
              <button className="btn-lg btn btn-primary">
                Start Your Project
              </button>
              <button className="btn-lg btn btn-outline hero-demo-btn">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>
                  {' '}
                  Watch Demo
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
            </div>
          </div>
          <div className="hero-hotspots">
            <div data-service="cloud" className="hero-hotspot">
              <div className="hero-hotspot-pulse"></div>
              <div className="hero-hotspot-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="hero-hotspot-label">
                <span>Cloud Infrastructure</span>
              </div>
            </div>
            <div data-service="ai" className="hero-hotspot">
              <div className="hero-hotspot-pulse"></div>
              <div className="hero-hotspot-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <div className="hero-hotspot-label">
                <span>AI Integration</span>
              </div>
            </div>
            <div data-service="security" className="hero-hotspot">
              <div className="hero-hotspot-pulse"></div>
              <div className="hero-hotspot-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="hero-hotspot-label">
                <span>Security First</span>
              </div>
            </div>
            <div data-service="dev" className="hero-hotspot">
              <div className="hero-hotspot-pulse"></div>
              <div className="hero-hotspot-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="hero-hotspot-label">
                <span>Custom Development</span>
              </div>
            </div>
          </div>
        </div>
        <div id="hero3DScene" className="hero-3d-scene"></div>
      </div>
      <div className="showcase-section">
        <div className="showcase-outer">
          <div className="showcase-primary">
            <div className="showcase-sticky-content">
              <h2 className="section-title">Our Core Capabilities</h2>
              <p className="section-content">
                Delivering excellence through cutting-edge technology solutions.
                Each service is crafted with precision, powered by innovation,
                and designed to scale with your ambitions.
              </p>
              <div className="showcase-nav">
                <button data-target="0" className="active showcase-nav-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Development</span>
                </button>
                <button data-target="1" className="showcase-nav-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Cloud</span>
                </button>
                <button data-target="2" className="showcase-nav-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                      <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                      <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                      <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                      <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                      <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                    </g>
                  </svg>
                  <span>AI Solutions</span>
                </button>
              </div>
            </div>
          </div>
          <div className="showcase-secondary">
            <div data-index="0" className="active showcase-card">
              <div className="showcase-card-demo">
                <canvas data-demo="code" className="showcase-canvas"></canvas>
              </div>
              <div className="showcase-card-content">
                <div className="showcase-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="showcase-card-title">
                  Custom Software Development
                </h3>
                <p className="showcase-card-description">
                  Full-stack development with modern frameworks, scalable
                  architectures, and pixel-perfect interfaces. From concept to
                  deployment, we build software that performs.
                </p>
                <ul className="showcase-card-features">
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>React, Vue, Angular expertise</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Microservices architecture</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>CI/CD pipeline integration</span>
                  </li>
                </ul>
              </div>
            </div>
            <div data-index="1" className="showcase-card">
              <div className="showcase-card-demo">
                <canvas data-demo="cloud" className="showcase-canvas"></canvas>
              </div>
              <div className="showcase-card-content">
                <div className="showcase-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="showcase-card-title">Cloud Infrastructure</h3>
                <p className="showcase-card-description">
                  Enterprise-grade cloud solutions on AWS, Azure, and Google
                  Cloud. Scalable, secure, and optimized for peak performance
                  with automated deployment pipelines.
                </p>
                <ul className="showcase-card-features">
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Multi-cloud deployment</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Auto-scaling infrastructure</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Cost optimization strategies</span>
                  </li>
                </ul>
              </div>
            </div>
            <div data-index="2" className="showcase-card">
              <div className="showcase-card-demo">
                <canvas data-demo="ai" className="showcase-canvas"></canvas>
              </div>
              <div className="showcase-card-content">
                <div className="showcase-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                      <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                      <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                      <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                      <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                      <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="showcase-card-title">
                  AI &amp; Machine Learning
                </h3>
                <p className="showcase-card-description">
                  Intelligent automation, predictive analytics, and neural
                  networks that transform data into actionable insights. Custom
                  AI models trained for your specific use cases.
                </p>
                <ul className="showcase-card-features">
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Natural language processing</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Computer vision systems</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Predictive analytics engines</span>
                  </li>
                </ul>
              </div>
            </div>
            <div data-index="3" className="showcase-card">
              <div className="showcase-card-demo">
                <canvas
                  data-demo="database"
                  className="showcase-canvas"
                ></canvas>
              </div>
              <div className="showcase-card-content">
                <div className="showcase-card-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                      <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                      <path d="M3 12a9 3 0 0 0 18 0"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="showcase-card-title">Data Engineering</h3>
                <p className="showcase-card-description">
                  Robust data pipelines, real-time processing, and secure
                  storage solutions. Transform raw data into strategic assets
                  with our advanced engineering capabilities.
                </p>
                <ul className="showcase-card-features">
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>ETL pipeline design</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Real-time data streaming</span>
                  </li>
                  <li>
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Data warehouse optimization</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="stats-section">
        <div className="stats-container">
          <canvas id="statsParticles" className="stats-particles"></canvas>
          <h2 className="section-title stats-title">Impact By Numbers</h2>
          <p className="stats-description section-content">
            Real results from real partnerships. Our commitment to excellence
            drives measurable success across every engagement.
          </p>
          <div className="stats-grid">
            <div className="stats-card">
              <div className="stats-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </g>
                </svg>
              </div>
              <div data-target="350" className="stats-card-value">
                <span>0</span>
              </div>
              <div className="stats-card-suffix">
                <span>+</span>
              </div>
              <div className="stats-card-label">
                <span>Projects Delivered</span>
              </div>
              <div className="stats-card-sublabel">
                <span>Across 12 industries</span>
              </div>
            </div>
            <div className="stats-card">
              <div className="stats-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <div data-target="98" className="stats-card-value">
                <span>0</span>
              </div>
              <div className="stats-card-suffix">
                <span>%</span>
              </div>
              <div className="stats-card-label">
                <span>Client Satisfaction</span>
              </div>
              <div className="stats-card-sublabel">
                <span>Average rating 4.9/5</span>
              </div>
            </div>
            <div className="stats-card">
              <div className="stats-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m5 12l7-7l7 7m-7 7V5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div data-target="3" className="stats-card-value">
                <span>0</span>
              </div>
              <div className="stats-card-suffix">
                <span>x</span>
              </div>
              <div className="stats-card-label">
                <span>Performance Boost</span>
              </div>
              <div className="stats-card-sublabel">
                <span>Average optimization gain</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="video-section">
        <div className="video-container">
          <h2 className="section-title video-title">Featured Work</h2>
          <p className="video-description section-content">
            Explore our flagship projects that showcase innovation, technical
            excellence, and transformative results for leading organizations
            worldwide.
          </p>
          <div className="video-featured">
            <div className="video-featured-player">
              <video
                src="https://videos.pexels.com/video-files/30769473/13161982_640_360_30fps.mp4"
                poster="https://images.pexels.com/photos/8636609/pexels-photo-8636609.jpeg"
                controls="true"
                className="video-featured-media"
              ></video>
              <svg width="48" height="48" viewBox="0 0 48 48">
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <circle r="20" cx="24" cy="24"></circle>
                  <path
                    d="M4.4 20c1.853 9.129 9.924 16 19.6 16s17.747-6.871 19.6-16"
                    strokeLinecap="round"
                  ></path>
                  <path
                    d="M5.664 16C8.75 23.064 15.8 28 24 28s15.25-4.936 18.336-12"
                    strokeLinecap="round"
                  ></path>
                  <path
                    d="M7.999 12c3.648 4.858 9.458 8 16.001 8s12.353-3.142 16.015-8M11.998 8c3.343 2.512 7.499 4 12.002 4s8.659-1.488 12.002-4"
                    strokeLinecap="round"
                  ></path>
                </g>
              </svg>
              <div className="video-featured-overlay">
                <button className="video-play-button">
                  <svg
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="video-featured-info">
                <h3 className="video-featured-title">
                  Global FinTech Platform
                </h3>
                <p className="video-featured-subtitle">
                  Real-time transaction processing at 50,000 TPS
                </p>
              </div>
            </div>
          </div>
          <div className="video-grid">
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Automotive technology project"
                  src="https://images.pexels.com/photos/3862627/pexels-photo-3862627.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">
                  Autonomous Vehicle Interface
                </h4>
                <p className="video-card-description">
                  Next-gen HMI with AR navigation
                </p>
              </div>
            </div>
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Development team collaboration"
                  src="https://images.pexels.com/photos/7988116/pexels-photo-7988116.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">Healthcare Data Platform</h4>
                <p className="video-card-description">
                  HIPAA-compliant patient analytics
                </p>
              </div>
            </div>
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Software development workspace"
                  src="https://images.pexels.com/photos/12899191/pexels-photo-12899191.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">E-Commerce AI Engine</h4>
                <p className="video-card-description">
                  Personalized recommendations at scale
                </p>
              </div>
            </div>
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Team meeting technology"
                  src="https://images.pexels.com/photos/7437491/pexels-photo-7437491.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">Smart City IoT Network</h4>
                <p className="video-card-description">
                  Connected infrastructure management
                </p>
              </div>
            </div>
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Technology professionals at work"
                  src="https://images.pexels.com/photos/1181461/pexels-photo-1181461.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">Blockchain Supply Chain</h4>
                <p className="video-card-description">
                  Transparent logistics tracking
                </p>
              </div>
            </div>
            <div className="video-card">
              <div className="video-card-thumbnail">
                <img
                  alt="Collaborative workspace"
                  src="https://images.pexels.com/photos/6804081/pexels-photo-6804081.jpeg?w=1500"
                  loading="lazy"
                />
                <div className="video-card-overlay">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="video-card-content">
                <h4 className="video-card-title">EdTech Learning Platform</h4>
                <p className="video-card-description">
                  Adaptive AI-powered education
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="process-section">
        <div className="process-container">
          <h2 className="section-title process-title">
            Our Engagement Process
          </h2>
          <p className="process-description section-content">
            A proven methodology that transforms complex challenges into elegant
            solutions through collaborative innovation and technical excellence.
          </p>
          <div className="process-bento">
            <div className="process-cell-hero process-cell">
              <div data-step="featured" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>01</span>
                </div>
                <h3 className="process-cell-title">Discovery &amp; Strategy</h3>
                <p className="process-cell-description">
                  Deep-dive workshops to understand your vision, challenges, and
                  objectives. We map user journeys, define KPIs, and create a
                  technical roadmap aligned with your business goals.
                </p>
                <ul className="process-cell-features">
                  <li>
                    <span>Stakeholder interviews</span>
                  </li>
                  <li>
                    <span>Technical feasibility analysis</span>
                  </li>
                  <li>
                    <span>Architecture planning</span>
                  </li>
                  <li>
                    <span>Timeline &amp; budget scoping</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="process-cell">
              <div data-step="2" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>02</span>
                </div>
                <h3 className="process-cell-title">Design &amp; Prototyping</h3>
                <p className="process-cell-description">
                  Wireframes, interactive prototypes, and visual design that
                  brings ideas to life before development begins.
                </p>
              </div>
            </div>
            <div className="process-cell">
              <div data-step="3" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>03</span>
                </div>
                <h3 className="process-cell-title">Agile Development</h3>
                <p className="process-cell-description">
                  Iterative sprints with continuous integration, automated
                  testing, and regular client feedback loops.
                </p>
              </div>
            </div>
            <div className="process-cell">
              <div data-step="4" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>04</span>
                </div>
                <h3 className="process-cell-title">Quality Assurance</h3>
                <p className="process-cell-description">
                  Comprehensive testing including unit, integration,
                  performance, and security assessments.
                </p>
              </div>
            </div>
            <div className="process-cell">
              <div data-step="5" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>05</span>
                </div>
                <h3 className="process-cell-title">Deployment &amp; Launch</h3>
                <p className="process-cell-description">
                  Seamless production deployment with zero downtime and
                  comprehensive monitoring setup.
                </p>
              </div>
            </div>
            <div className="process-cell">
              <div data-step="6" className="process-cell-3d"></div>
              <div className="process-cell-content">
                <div className="process-cell-number">
                  <span>06</span>
                </div>
                <h3 className="process-cell-title">Support &amp; Evolution</h3>
                <p className="process-cell-description">
                  Ongoing maintenance, performance optimization, and feature
                  enhancements as your needs grow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="testimonials-section">
        <div className="testimonials-container">
          <canvas
            id="testimonialsParticles"
            className="testimonials-particles"
          ></canvas>
          <div className="testimonials-header">
            <h2 className="section-title">Trusted By Industry Leaders</h2>
            <p className="section-content">
              Our partnerships speak volumes. See what our clients say about
              working with NeonFlux.
            </p>
          </div>
          <div className="testimonials-featured">
            <div className="testimonials-quote-icon">
              <svg
                width="64"
                xmlns="http://www.w3.org/2000/svg"
                height="64"
                viewBox="0 0 24 24"
              >
                <path
                  d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <p className="testimonials-featured-text">
              NeonFlux transformed our digital infrastructure with a level of
              technical sophistication we didn&apos;t think possible. Their team
              delivered a cloud-native platform that handles 10 million daily
              users with 99.99% uptime. Exceptional work from discovery to
              deployment.
            </p>
            <div className="testimonials-featured-author">
              <img
                alt="Sarah Chen"
                src="https://images.pexels.com/photos/27086242/pexels-photo-27086242.jpeg?w=1500"
                loading="lazy"
                className="testimonials-author-image"
              />
              <div className="testimonials-author-info">
                <div className="testimonials-author-name">
                  <span>Sarah Chen</span>
                </div>
                <div className="testimonials-author-title">
                  <span>CTO, GlobalTech Solutions</span>
                </div>
              </div>
              <div className="testimonials-rating">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="testimonials-grid">
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                The AI recommendation engine they built increased our conversion
                rate by 340%. Absolutely game-changing.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="Michael Rodriguez"
                  src="https://images.pexels.com/photos/27086301/pexels-photo-27086301.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>Michael Rodriguez</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>VP Product, RetailX</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                Professional, responsive, and deeply technical. They tackled our
                legacy system migration with surgical precision.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="Emily Watson"
                  src="https://images.pexels.com/photos/27086245/pexels-photo-27086245.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>Emily Watson</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>CIO, HealthFirst</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                Their blockchain solution gave us complete supply chain
                transparency. We can now track every product from factory to
                customer.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="David Kim"
                  src="https://images.pexels.com/photos/27086273/pexels-photo-27086273.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>David Kim</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>Operations Director, LogiTech</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                Reduced our cloud infrastructure costs by 65% while doubling
                performance. Incredible optimization work.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="Jennifer Park"
                  src="https://images.pexels.com/photos/27086218/pexels-photo-27086218.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>Jennifer Park</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>CFO, DataCorp</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                From prototype to production in 8 weeks. Their agile process
                kept us on schedule and within budget.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="Alex Thompson"
                  src="https://images.pexels.com/photos/27086270/pexels-photo-27086270.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>Alex Thompson</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>Founder, StartupHub</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonials-card">
              <div className="testimonials-card-rating">
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <svg
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <p className="testimonials-card-text">
                The mobile app they created has 4.8 stars with over 100k
                downloads. Users love the intuitive interface.
              </p>
              <div className="testimonials-card-author">
                <img
                  alt="Rachel Green"
                  src="https://images.pexels.com/photos/27086167/pexels-photo-27086167.jpeg?w=1500"
                  loading="lazy"
                  className="testimonials-card-image"
                />
                <div className="testimonials-card-info">
                  <div className="testimonials-card-name">
                    <span>Rachel Green</span>
                  </div>
                  <div className="testimonials-card-role">
                    <span>Product Lead, MobileFirst</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta-section">
        <div className="cta-outer">
          <canvas id="ctaParticles" className="cta-particles"></canvas>
          <div className="cta-card">
            <div className="cta-3d-accent"></div>
            <div className="cta-content">
              <h2 className="cta-title section-title">
                Ready to Build Something Extraordinary?
              </h2>
              <p className="cta-description section-content">
                Let&apos;s transform your vision into a cutting-edge digital
                solution. Schedule a consultation with our technical team and
                discover what&apos;s possible.
              </p>
              <form
                action="/contact"
                method="POST"
                data-form-id="534faa28-1d39-423c-8623-a254157bd0fe"
                className="cta-form"
              >
                <div className="cta-form-row">
                  <input
                    type="text"
                    id="thq_true_KOap"
                    name="true"
                    required="true"
                    placeholder="Your Name"
                    data-form-field-id="thq_true_KOap"
                    className="cta-input"
                  />
                  <input
                    type="email"
                    id="thq_email_gAC5"
                    name="email"
                    required="true"
                    placeholder="Email Address"
                    data-form-field-id="thq_email_gAC5"
                    className="cta-input"
                  />
                </div>
                <div className="cta-form-row">
                  <input
                    type="tel"
                    id="thq_phone_27X0"
                    name="phone"
                    placeholder="Phone Number"
                    data-form-field-id="thq_phone_27X0"
                    className="cta-input"
                  />
                  <input
                    type="text"
                    id="thq_company_zl41"
                    name="company"
                    placeholder="Company"
                    data-form-field-id="thq_company_zl41"
                    className="cta-input"
                  />
                </div>
                <textarea
                  id="thq_message__IF5"
                  name="message"
                  rows="4"
                  required="true"
                  placeholder="Tell us about your project..."
                  data-form-field-id="thq_message__IF5"
                  className="cta-textarea"
                ></textarea>
                <div className="cta-form-actions">
                  <button
                    id="thq_button_QTFE"
                    name="button"
                    type="submit"
                    data-form-field-id="thq_button_QTFE"
                    className="cta-submit btn-xl btn btn-primary"
                  >
                    <span>Start Your Project</span>
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                  <div className="cta-trust">
                    <svg
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>Secure &amp; confidential consultation</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<style>
        @keyframes heroFadeIn {from {opacity: 0;}
to {opacity: 1;}}@keyframes heroSlideUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes heroPulse {0% {transform: translate(-50%, -50%) scale(0.8);
opacity: 0.3;}
50% {transform: translate(-50%, -50%) scale(1);
opacity: 0.1;}
100% {transform: translate(-50%, -50%) scale(1.2);
opacity: 0;}}@keyframes heroFloat {0%,100% {transform: translateY(0);}
50% {transform: translateY(-20px);}}@keyframes statsFloat {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}@keyframes ctaPulse {0%,100% {transform: scale(1);}
50% {transform: scale(1.2);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container6">
        <div className="home-container7">
          <Script
            html={`<script defer data-name="neonflux-interactive">
(function(){
  const heroParticles = document.getElementById("heroParticles")
  const statsParticles = document.getElementById("statsParticles")
  const testimonialsParticles = document.getElementById("testimonialsParticles")
  const ctaParticles = document.getElementById("ctaParticles")

  function createParticleSystem(canvas) {
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight

    const particles = []
    const particleCount = 80

    class Particle {
      constructor() {
        this.reset()
      }

      reset() {
        this.x = Math.random() * canvas.width
        this.y = Math.random() * canvas.height
        this.vx = (Math.random() - 0.5) * 0.5
        this.vy = (Math.random() - 0.5) * 0.5
        this.radius = Math.random() * 2 + 1
        this.opacity = Math.random() * 0.5 + 0.2
      }

      update() {
        this.x += this.vx
        this.y += this.vy

        if (this.x < 0 || this.x > canvas.width) this.vx *= -1
        if (this.y < 0 || this.y > canvas.height) this.vy *= -1
      }

      draw() {
        ctx.beginPath()
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2)
        ctx.fillStyle = \`rgba(100, 181, 246, \${this.opacity})\`
        ctx.fill()
      }
    }

    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle())
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      particles.forEach((particle) => {
        particle.update()
        particle.draw()
      })

      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x
          const dy = particles[i].y - particles[j].y
          const distance = Math.sqrt(dx * dx + dy * dy)

          if (distance < 100) {
            ctx.beginPath()
            ctx.moveTo(particles[i].x, particles[i].y)
            ctx.lineTo(particles[j].x, particles[j].y)
            ctx.strokeStyle = \`rgba(100, 181, 246, \${0.15 * (1 - distance / 100)})\`
            ctx.lineWidth = 1
            ctx.stroke()
          }
        }
      }

      requestAnimationFrame(animate)
    }

    animate()

    window.addEventListener("resize", () => {
      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
    })
  }

  createParticleSystem(heroParticles)
  createParticleSystem(statsParticles)
  createParticleSystem(testimonialsParticles)
  createParticleSystem(ctaParticles)

  const showcaseNavItems = document.querySelectorAll(".showcase-nav-item")
  const showcaseCards = document.querySelectorAll(".showcase-card")

  showcaseNavItems.forEach((item, index) => {
    item.addEventListener("click", () => {
      showcaseNavItems.forEach((nav) => nav.classList.remove("active"))
      showcaseCards.forEach((card) => card.classList.remove("active"))

      item.classList.add("active")
      showcaseCards[index]?.classList.add("active")
    })
  })

  function createShowcaseDemo(canvas, type) {
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight

    let time = 0

    function drawCode() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const lineCount = 15
      const lineHeight = canvas.height / lineCount

      for (let i = 0; i < lineCount; i++) {
        const y = i * lineHeight + lineHeight / 2
        const width = Math.random() * canvas.width * 0.7 + canvas.width * 0.1
        const x = canvas.width * 0.1

        ctx.fillStyle = \`rgba(255, 255, 255, \${0.2 + Math.sin(time + i) * 0.1})\`
        ctx.fillRect(x, y - 3, width, 6)
      }

      time += 0.02
    }

    function drawCloud() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const nodeCount = 8
      const centerX = canvas.width / 2
      const centerY = canvas.height / 2
      const radius = Math.min(canvas.width, canvas.height) * 0.3

      for (let i = 0; i < nodeCount; i++) {
        const angle = (i / nodeCount) * Math.PI * 2 + time
        const x = centerX + Math.cos(angle) * radius
        const y = centerY + Math.sin(angle) * radius

        ctx.beginPath()
        ctx.arc(x, y, 8, 0, Math.PI * 2)
        ctx.fillStyle = "rgba(255, 255, 255, 0.4)"
        ctx.fill()

        ctx.beginPath()
        ctx.moveTo(centerX, centerY)
        ctx.lineTo(x, y)
        ctx.strokeStyle = "rgba(255, 255, 255, 0.2)"
        ctx.lineWidth = 2
        ctx.stroke()
      }

      ctx.beginPath()
      ctx.arc(centerX, centerY, 12, 0, Math.PI * 2)
      ctx.fillStyle = "rgba(255, 255, 255, 0.6)"
      ctx.fill()

      time += 0.015
    }

    function drawAI() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const waves = 5
      const amplitude = 30
      const frequency = 0.05

      for (let w = 0; w < waves; w++) {
        ctx.beginPath()

        for (let x = 0; x < canvas.width; x++) {
          const y = canvas.height / 2 + Math.sin(x * frequency + time + w * 0.5) * amplitude
          if (x === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }

        ctx.strokeStyle = \`rgba(255, 255, 255, \${0.3 - w * 0.05})\`
        ctx.lineWidth = 3
        ctx.stroke()
      }

      time += 0.03
    }

    function drawDatabase() {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      const layers = 4
      const layerHeight = canvas.height / (layers + 2)
      const ellipseWidth = canvas.width * 0.6
      const ellipseHeight = 30

      for (let i = 0; i < layers; i++) {
        const y = layerHeight * (i + 1.5)
        const offset = Math.sin(time + i * 0.5) * 10

        ctx.beginPath()
        ctx.ellipse(canvas.width / 2 + offset, y, ellipseWidth / 2, ellipseHeight / 2, 0, 0, Math.PI * 2)
        ctx.strokeStyle = "rgba(255, 255, 255, 0.4)"
        ctx.lineWidth = 2
        ctx.stroke()
        ctx.fillStyle = "rgba(255, 255, 255, 0.1)"
        ctx.fill()
      }

      time += 0.02
    }

    function animate() {
      switch (type) {
        case "code":
          drawCode()
          break
        case "cloud":
          drawCloud()
          break
        case "ai":
          drawAI()
          break
        case "database":
          drawDatabase()
          break
        default:
          drawCode()
      }

      requestAnimationFrame(animate)
    }

    animate()
  }

  const showcaseCanvases = document.querySelectorAll(".showcase-canvas")
  showcaseCanvases.forEach((canvas) => {
    const demoType = canvas.getAttribute("data-demo")
    createShowcaseDemo(canvas, demoType)
  })

  const statsCards = document.querySelectorAll(".stats-card")

  const observerOptions = {
    threshold: 0.5,
    rootMargin: "0px",
  }

  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const valueElement = entry.target.querySelector(".stats-card-value")
        const target = parseInt(valueElement.getAttribute("data-target"))
        let current = 0
        const increment = target / 60
        const duration = 2000
        const stepTime = duration / 60

        const counter = setInterval(() => {
          current += increment
          if (current >= target) {
            valueElement.textContent = target
            clearInterval(counter)
          } else {
            valueElement.textContent = Math.floor(current)
          }
        }, stepTime)

        statsObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)

  statsCards.forEach((card) => {
    statsObserver.observe(card)
  })

  const videoPlayButtons = document.querySelectorAll(".video-play-button")
  videoPlayButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const player = button.closest(".video-featured-player")
      const video = player.querySelector("video")
      const overlay = player.querySelector(".video-featured-overlay")

      video.setAttribute("controls", "controls")
      video.play()
      overlay.style.display = "none"
    })
  })

  const processCells = document.querySelectorAll(".process-cell-3d")
  processCells.forEach((cell) => {
    cell.parentElement.addEventListener("mouseenter", () => {
      cell.style.transform = "translate(30%, -30%) rotate(45deg)"
    })

    cell.parentElement.addEventListener("mouseleave", () => {
      cell.style.transform = "translate(40%, -40%) rotate(0deg)"
    })
  })

  const heroHotspots = document.querySelectorAll(".hero-hotspot")
  heroHotspots.forEach((hotspot) => {
    hotspot.addEventListener("click", () => {
      const service = hotspot.getAttribute("data-service")
      console.log(\`Service clicked: \${service}\`)
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
